var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"page-content":true}},[_c('f7-navbar',[_c('f7-nav-title',{staticClass:"text-madai"},[_vm._v("Gracias")])],1),_c('f7-block',[_c('h2',[_vm._v("Gracias por suscribirte a nuestro boletín")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }